import styled from "styled-components";

export const NavLinkStyles = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[20]} ${({ theme }) => theme.spacing[24]};
  margin: 4px 12px;
  border-radius: 8px;
  background: ${({ $isActive, theme }) => ($isActive ? theme.colors.accent[50] : "transparent")};
  transition: background 0.2s ease;

  ${({ $isActive, theme }) => !$isActive && `
    &:hover {
      background: ${theme.colors.accent[50]};
    }

    &:hover .linkName {
      color: ${theme.colors.semantic.text.strong};
    }

    &:hover path {
      fill: ${theme.colors.semantic.text.strong};
    }
  `}

  .linkName {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ $isActive, theme }) => ($isActive ? theme.colors.accent[500] : theme.colors.primary[600])};
    margin-left: 15px;
    transition: color 0.2s ease;
  }

  path {
    fill: ${({ $isActive, theme }) => ($isActive ? theme.colors.accent[500] : theme.colors.primary[600])};
    transition: fill 0.2s ease;
  }

  .lockIco {
    display: flex;
    margin-left: auto;
    color: ${({ theme }) => theme.colors.primary[400]};

    /* The lock is a stroke glyph — undo the fill rule above. */
    path {
      fill: none;
    }
  }
`;
